// Environment Variables and Constants
// This file centralizes all environment variable access with proper validation

// Environment validation helper
const getEnvVar = (key: string, required: boolean = false) => {
  // Vite syntax (commented out for webpack compatibility)
  // const value = import.meta.env[key];
  
  // Webpack syntax with safety check
  const value = typeof process !== 'undefined' && process.env?.[key];
  
  if (required && !value) {
    console.warn(`Required environment variable ${key} is not set`);
    return null;
  }
  
  return value;
};

// Payment Gateway Configuration
export const FLW_PUBLIC_KEY = getEnvVar('VITE_FLW_PUBLIC_KEY', false) || 'FLWPUBK_TEST-c648340cced9e60b9e8253912c4af39d-X';

// Supabase Configuration (if needed in the future)
export const SUPABASE_URL = getEnvVar('VITE_SUPABASE_URL', false) || 'https://ybtseuqclexmqlolgztv.supabase.co';
export const SUPABASE_ANON_KEY = getEnvVar('VITE_SUPABASE_ANON_KEY', false) || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlidHNldXFjbGV4bXFsb2xgenR2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE1NDYzODYsImV4cCI6MjA2NzEyMjM4Nn0.ZLinMKiTrejYaIXByaQRbg4xUSdmsOGN96P6ezPYs68';

// App Configuration
export const APP_NAME = 'GreenCard Sustainability Manager';
export const APP_VERSION = '1.0.0';

// Environment validation function
export const validateEnvironment = () => {
  const errors: string[] = [];
  
  if (!FLW_PUBLIC_KEY) {
    errors.push('VITE_FLW_PUBLIC_KEY is required but not set');
  }
  
  if (errors.length > 0) {
    console.warn(`Environment validation warnings:\n${errors.join('\n')}`);
  }
  
  return true;
}; 